<template>
  <div class="storeApply">
    <div class="list">
      <div class="item flex ali_center" v-if="type == 1">
        <div class="left">微信子商户号</div>
        <input
          type="spen"
          style="text-align: right;color: #999;"
          v-model="shopname"
          disabled
          placeholder="请填写微信子商户号"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
        <spen :data-clipboard-text="shopname" class="copy copy-data">复制</spen>
      </div>
      <div class="item flex ali_center" v-if="type == 2">
        <div class="left" style="width: 2.20rem;">支付宝子商户号</div>
        <input
          type="spen"
          style="width: 4.10rem;text-align: right;color: #999;"
          v-model="shopname"
          disabled
          placeholder="请填写支付宝子商户号"
          placeholder-style="color: #ccc;font-size:0.30rem"
        />
        <spen :data-clipboard-text="shopname" class="copy copy-data">复制</spen>
      </div>
      <div class="item flex ali_center">
        <div class="left">商户名称</div>
        <input
          type="spen"
          style="text-align: right;width: 5.00rem;"
          v-model="realname"
          disabled
          placeholder="请填写商户名称"
          placeholder-style="color: #ccc;font-size:30rem"
        />
      </div>
      <div class="logo">
        <div class="left on" style="font-size: 0.26rem;color: #333;"></div>
        <spen
          class="iconfont icon-tongzhi"
          style="color: #fc4141;margin-right: 0.10rem;"
        ></spen>
        请商户联系人<spen style="color: #fc4141;margin:0 0.10rem;">
          {{ contactName }} </spen
        >使用{{ type == 1 ? "微信" : "支付宝" }}扫码完成认证操作
      </div>
      <div
        class="box"
        :style="
          type == 1
            ? 'background-color: #edfff6;'
            : 'background-color: #edf7ff;'
        "
      >
        <div
          class="bgColor flex flex_center ali_center"
          style="height: 0.8rem;"
          v-if="type == 1"
        >
          <spen class="iconfont icon-weixin2" style="color: #23d96e;"></spen>
          <spen class="welcome">
            欢迎成为微信支付商家
          </spen>
        </div>
        <div
          class="bgColor2 flex flex_center ali_center"
          style="height: 0.8rem;"
          v-if="type == 2"
        >
          <spen class="iconfont icon-zhifubao" style="color: #0e98fd;"></spen>
          <spen class="welcome">
            欢迎成为支付宝支付商家
          </spen>
        </div>
        <img
          lazy-load="true"
          class="pic"
          src="../../assets/images/wx.png"
          mode=""
          v-if="type == 1"
        />
        <img
          lazy-load="true"
          class="pic"
          src="../../assets/images/zfb.png"
          mode=""
          v-if="type == 2"
        />
      </div>
    </div>
    <div class="submit" @click="onSelect(0)" v-if="show">保存二维码</div>
  </div>
</template>

<script>
import ClipboardJS from "clipboard";
export default {
  name: "storeApply",
  data() {
    return {
      checked: false,
      showAddress: false,
      show: false,
      valueArr: [0, 0, 0],
      id: 0,
      addressspen: "请选择门店地址",
      area: "请选择门店所在街道",
      addressList: [],
      shopname: "",
      realname: "",
      contactName: "",
      phone: "",
      address: "",
      detail: "",
      desc: "",
      logo: "",
      shop_bg: "",
      license: "",
      card_from: "",
      card_back: "",
      latitude: 0,
      longitude: 0,
      latitude2: 0,
      longitude2: 0,
      province: "",
      city: "",
      district: "",
      province2: "",
      city2: "",
      district2: "",
      show_add3: false,
      combo: 0,
      stick: "请选择让利比例",
      address_jw: "",
      showAddress2: false,
      addressList2: [],
      valueArr2: [0],
      showStreet: false,
      type: 1,
      logoUrl1: require("../../assets/images/wx.png"),
      logoUrl2: require("../../assets/images/zfb.png")
    };
  },
  mounted() {
    let res = this.$route.query;
    let ua = navigator.userAgent;
    if (ua.indexOf("APICloud") > -1) {
      this.show = true;
    }
    if (res.type) {
      this.type = res.type;
    }
    if (res.id) {
      let u = res.id.split("_");
      this.shopname = u[0];
    }
    if (res.mercName) {
      this.realname = res.mercName;
    }
    if (res.contactName) {
      this.contactName = res.contactName;
    }
    if (this.shopname.indexOf("_") > -1) {
      let u = this.shopname.split("_");
      this.shopname = u[0];
    }
    this.$nextTick(function() {
      let copybtn = document.getElementsByClassName("copy-data");
      const clipboard = new ClipboardJS(copybtn);
      clipboard.on("success", () => {
        this.$dialog.success("复制成功");
      });
    });
  },
  methods: {
    onSelect(item) {
      let that = this;
      var filename = "yqp_" + new Date().getTime() + ".jpg";
      if (item == 0) {
        var resultList = window.api.hasPermission({
          list: ["photos"]
        });
        var granted = resultList[0].granted;
        if (!granted) {
          let has = confirm("应用需要获取存储权限才能下载图片");
          if (has) {
            window.api.requestPermission({
              list: ["photos"]
            }),
              function(res) {
                alert(JSON.stringify(res));
              };
          }
          return;
        }
        window.api.download(
          {
            url: that.type == 1 ? that.logoUrl1 : that.logoUrl2,
            savePath: "fs://" + filename
          },
          function(ret, err) {
            that.show = false;
            if (ret.state == 1) {
              window.api.saveMediaToAlbum(
                {
                  path: "fs://" + filename
                },
                function(ret, error) {
                  if (ret && ret.status) {
                    that.$tips({
                      title: "保存成功"
                    });
                  } else {
                    console.log(error);
                    that.$tips({
                      title: "保存失败"
                    });
                  }
                }
              );
            } else {
              console.log(err);
              that.$tips({
                title: "保存失败"
              });
            }
          }
        );
      }
    },
    // copy(res) {
    //   handleClipboard(
    //     res,
    //     event,
    //     () => {
    //       this.$tips({
    //         title: "复制成功"
    //       });
    //     },
    //     () => {
    //       this.$tips({
    //         title: "复制失败"
    //       });
    //     }
    //   );
    // },
    submit2() {
      window.location.href = "https://weixin.qq.com/q/0277ou8loreR210000g07A";
    },
    submit3() {
      window.location.href = "https://qr.alipay.com/0cb177494bbqry2aijbcb9d";
    },
    checkeds() {
      this.checked = !this.checked;
    },
    // precise() {
    //   let that = this;
    //   uni.chooseLocation({
    //     // keyword: that.addressspen + that.detail,
    //     success: function(res) {
    //       that.latitude2 = res.latitude;
    //       that.longitude2 = res.longitude;
    //       that.address_jw = "纬度：" + res.latitude + ",经度：" + res.longitude;
    //     },
    //     fail() {
    //       that.$tips({
    //         title: "选择失败，请重新选择"
    //       });
    //     }
    //   });
    // },
    Combo(type) {
      this.combo = type.num;
      this.stick = type.name;
      this.show_add3 = false;
    },
    showCombo() {
      this.show_add3 = false;
    },
    sureAddress() {
      let province = this.province[this.valueArr[0]].n;
      let city = this.city[this.valueArr[1]].n;
      let district = this.district[this.valueArr[2]].n;
      this.province2 = province;
      this.city2 = city;
      this.district2 = district;
      this.addressspen = province + " " + city + " " + district;
      this.cityId = this.district[this.valueArr[2]].v;
      this.address = {
        province,
        city,
        district,
        city_id: this.cityId
      };
      this.gettreea(city, district);
      this.showAddress = false;
    },
    sureAddress2() {
      this.area = this.addressList2[this.valueArr2[0]].name;
      console.log(this.area);
      this.showAddress2 = false;
    },
    // gettreea(city, area) {
    //   gettreea({
    //     city,
    //     area
    //   }).then(res => {
    //     this.addressList2 = res.data;
    //     if (res.data.length > 0) {
    //       this.showStreet = true;
    //     }
    //   });
    // },
    changePicker2(e) {
      let indexArr = e.detail.value;
      console.log(indexArr);
      if (indexArr[0] !== this.valueArr2[0]) {
        this.valueArr2 = [indexArr[0]];
        return;
      }
      this.valueArr2 = indexArr;
    },
    changePicker(e) {
      let indexArr = e.detail.value;
      if (indexArr[0] !== this.valueArr[0]) {
        this.valueArr = [indexArr[0], 0, 0];
        this.city = this.addressList[indexArr[0]].c;
        this.district = this.addressList[indexArr[0]].c[0].c;
        return;
      }
      if (indexArr[1] !== this.valueArr[1]) {
        this.valueArr = [indexArr[0], indexArr[1], 0];
        this.district = this.addressList[indexArr[0]].c[indexArr[1]].c;
        return;
      }
      this.valueArr = indexArr;
    },
    // getCity() {
    //   getCity()
    //     .then(res => {
    //       this.recity(res.data);
    //       this.addressList = res.data;
    //     })
    //     .catch(res => {
    //       console.log(res);
    //     });
    // },
    // chooseAddress() {
    //   let that = this;
    //   uni.chooseLocation({
    //     success(res) {
    //       that.latitude = res.latitude;
    //       that.longitude = res.longitude;
    //       that.address = res.address;
    //     },
    //     fail(res) {
    //       console.log(res);
    //     }
    //   });
    // },
    recity(arr) {
      let province = [],
        city = [],
        area = [];
      if (arr.length) {
        let citychildren = arr[0].c || [];
        let areachildren = citychildren.length ? citychildren[0].c || [] : [];
        arr.forEach(item => {
          province.push(item);
        });
        citychildren.forEach(item => {
          city.push(item);
        });
        areachildren.forEach(item => {
          area.push(item);
        });
        this.province = province;
        this.city = city;
        this.district = area;
      }
    },
    submit() {
      if (!this.shopname)
        return this.$tips({
          title: "请填写店铺名字"
        });
      if (!this.realname)
        return this.$tips({
          title: "请填写联系人"
        });
      if (!this.phone)
        return this.$tips({
          title: "请填写联系电话"
        });
      if (this.address.length > 0)
        return this.$tips({
          title: "请填写门店地址"
        });
      if (!this.detail)
        return this.$tips({
          title: "请填写详细地址"
        });
      if (!this.latitude2)
        return this.$tips({
          title: "请选择门店经纬度"
        });
      if (!this.combo)
        return this.$tips({
          title: "请选择让利比例"
        });
      if (!this.desc)
        return this.$tips({
          title: "请填写门店简介"
        });
      if (!this.logo)
        return this.$tips({
          title: "请上传门店logo"
        });
      if (!this.shop_bg)
        return this.$tips({
          title: "请上传店铺背景图"
        });
      if (!this.license)
        return this.$tips({
          title: "请上传营业执照"
        });
      if (!this.card_from)
        return this.$tips({
          title: "请上传证件正面照"
        });
      if (!this.card_back)
        return this.$tips({
          title: "请上传证件反面照"
        });
      if (!this.checked)
        return this.$tips({
          title: "请阅读并同意《商家入驻协议》"
        });
      let data = {
        shopname: this.shopname,
        name: this.realname,
        phone: this.phone,
        address: this.addressspen,
        province: this.province2,
        city: this.city2,
        area: this.district2,
        detailed_address: this.detail,
        introduction: this.desc,
        logo: this.logo,
        shop_bg: this.shop_bg,
        img: this.license,
        img1: this.card_from,
        img2: this.card_back,
        payserver: this.combo,
        latitude: this.latitude2,
        longitude: this.longitude2,
        treea: this.area == "请选择门店所在街道" ? "" : this.area
      };
      console.log(data);
      // applyStore(data)
      //   .then(res => {
      //     this.$tips(
      //       {
      //         title: res.msg
      //       },
      //       {
      //         tab: 1
      //       }
      //     );
      //   })
      //   .catch(res => {
      //     this.$tips({
      //       title: res.msg
      //     });
      //   });
    }
    // upload(type) {
    //   uploadImg()
    //     .then(res => {
    //       this.$tips({
    //         title: res.msg
    //       });
    //       this[type] = res.data.url;
    //       console.log(this[type]);
    //     })
    //     .catch(res => {
    //       this.$tips({
    //         title: res.msg
    //       });
    //     });
    // }
  }
};
</script>

<style lang="scss" scoped>
.storeApply {
  padding-bottom: 0.1rem;

  .list {
    background-color: #fff;

    .item2 {
      padding: 0 0.22rem;
      height: 0.9rem;
      background-color: #fff;
      font-size: 0.28rem;
      border-bottom: 0.1rem solid #eee;

      .left {
        width: 2.45rem;
        // color: #333;
      }

      .right {
        width: 6rem;

        .iconfont {
          color: #fc4141;
          font-size: 0.5rem;
        }

        .icon-jinru {
          color: #666;
          font-size: 0.36rem;
        }
      }
    }

    .item {
      min-height: 0.99rem;
      border-bottom: 0.01rem solid #dcdcdc;
      padding: 0 0.23rem;

      .left {
        width: 2rem;
        font-size: 0.3rem;
        line-height: 0.99rem;
      }

      input {
        width: 4.3rem;
        font-size: 0.3rem;
      }

      spenarea {
        margin-top: -0.12rem;
        width: 100%;
        height: 1.5rem;
        padding-bottom: 0.3rem;
      }

      .address {
        width: 5.46rem;

        .a {
          width: 5rem;
          font-size: 0.3rem;
        }

        .iconfont {
          font-size: 0.34rem;
        }
      }
    }

    .logo {
      padding: 0 0.28rem;
      padding-bottom: 0.6rem;

      .box {
        padding-bottom: 0.4rem;
        position: relative;
        border-radius: 0.2rem;

        .bgColor {
          display: flex;
          justify-content: center;
          position: absolute;
          top: 0.66rem;
          left: 50%;
          transform: translate(-50%, -25%);
          width: 100%;
          height: 3.8rem;
          border-radius: 0.2rem 0.2rem 35% 35%;
          background-image: linear-gradient(to right, #60ad7b, #60ad7b);

          .icon-weixinzhifu {
            margin-top: 0.6rem;
            display: block;
            text-align: center;
            font-size: 0.5rem;
            color: #fff;
          }

          .welcome {
            margin-top: 0.3rem;
            display: inline-block;
            padding: 0 0.3rem;
            height: 0.6rem;
            line-height: 0.6rem;
            background-color: rgba(0, 0, 0, 0.2);
            text-align: center;
            color: #fff;
            border-radius: 0.3rem;
            margin-left: 1.87rem;
          }
        }

        .bgColor2 {
          display: flex;
          justify-content: center;
          position: absolute;
          top: 0.66rem;
          left: 50%;
          transform: translate(-50%, -25%);
          width: 100%;
          height: 3.8rem;
          border-radius: 0.2rem 0.2rem 35% 35%;
          background-image: linear-gradient(to right, #4774ea, #4774ea);

          .icon-zhifubaozhifu {
            margin-top: 0.6rem;
            display: block;
            text-align: center;
            font-size: 0.5rem;
            color: #fff;
          }

          .welcome {
            margin-top: 0.3rem;
            display: inline-block;
            padding: 0 0.3rem;
            height: 0.6rem;
            line-height: 0.6rem;
            background-color: rgba(0, 0, 0, 0.2);
            text-align: center;
            color: #fff;
            border-radius: 0.3rem;
            margin-left: 1.74rem;
          }
        }
      }

      .left {
        font-size: 0.3rem;
        line-height: 1.1rem;
        font-weight: 700;
        // text-align: center;

        .a {
          font-weight: 500;
          color: #999;
        }
      }

      .pic {
        padding: 0.3rem;
        margin-top: 2rem;
        margin-left: 1.97rem;
        width: 3rem;
        height: 3rem;
        background-color: #fff;
        border-radius: 0.2rem;
      }
    }

    .license {
      padding: 0 0.28rem;

      .left {
        font-size: 0.3rem;
        line-height: 1.1rem;
        font-weight: 700;
      }

      .pic {
        margin-left: 0.12rem;
        width: 4rem;
        height: 4rem;
      }

      .tips {
        width: 3rem;
        color: #999;
        font-size: 0.26rem;
        margin-top: 0.24rem;
        text-align: center;
      }
    }

    .card {
      padding: 0 0.8rem 0.6rem 0.4rem;

      .title {
        line-height: 1rem;
        font-size: 0.26rem;
      }

      .img_list {
        .item_1 {
          width: 3rem;

          .pic {
            width: 3rem;
            height: 2.06rem;
            margin-bottom: 0.24rem;
          }

          .tips {
            color: #999;
            font-size: 0.26rem;
            text-align: center;
          }
        }
      }
    }
  }

  .submit {
    width: 6.9rem;
    line-height: 0.9rem;
    text-align: center;
    background-color: #fc4141;
    color: #fff;
    border-radius: 0.45rem;
    margin: 0.6rem 0.3rem 0.3rem;
    margin-top: 3rem;
  }
}

.addressWrapper {
  .btns {
    width: 100%;
    height: 0.86rem;
    position: fixed;
    bottom: 6rem;
    left: 0;
    z-index: 556;

    background-color: #fff;
    text-align: center;
    font-size: 0.26rem;
    padding: 0 0.3rem;
    border-bottom: 0.01rem solid #eee;

    .cancel {
      color: #666;
    }

    .sure {
      color: #007aff;
    }
  }

  .pickerdiv {
    width: 100%;
    height: 6rem;
    position: fixed !important;
    bottom: 0;
    left: 0;
    z-index: 556;
    background-color: #fff;
    text-align: center;
  }
}

.detail {
  display: flex;
  align-items: center;
  margin-top: 0.2rem;
  margin-left: 0.24rem;
  color: #333;
}

.examine {
  padding: 0 0.3rem;
  text-align: right;
  color: #fc4141;
  margin-bottom: 1rem;
}

.copy {
  // margin-top: 0.26rem;
  height: 0.5rem;
  padding: 0.04rem;
  border: 1px solid #589bcd;
  border-radius: 0.1rem;
  margin-left: 0.1rem;
  color: #589bcd;
  font-size: 0.24rem;
  text-align: center;
}
.flex {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

img {
  display: block;
  width: 100%;
  height: auto;
}

.flex.flex_between {
  justify-content: space-between;
  -webkit-justify-content: space-between;
}
.flex.flex_around {
  justify-content: space-around;
  -webkit-justify-content: space-around;
}
.flex.ali_center {
  align-items: center;
  -webkit-align-items: center;
}
.flex.flex_center {
  justify-content: center;
  -webkit-justify-content: center;
}
.flex_col {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
}
</style>
